import { Box, styled } from "@mui/material";

export const CustomCardBox = styled(Box)({
  display: "flex",
  alignItems: "center",
  border: "1px solid #B9B9B9",
  backgroundColor: "#FFFFFF",
  borderRadius: "6px",
  padding: "10px",
  flex: "0 1 374px",
  //width: "374px",
  cursor: "pointer",
  margin: "0px 24px 24px 0px",
  maxWidth: "374px",
  "&:hover": {
    border: "1px solid #BF295C",
    backgroundColor: "#FFF8FA",
  },
});
